// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.8786 22.6174L12.1576 22.4042C14.0863 22.0827 15.5 20.414 15.5 18.4586V16H20.8195C22.0554 16 22.9955 14.8903 22.7923 13.6712L21.1257 3.6712C20.9649 2.70683 20.1306 2 19.1529 2H7V13.1978L10.8786 22.6174ZM4 14V2H2V14H4Z"}}]};

const ThumbDownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-down-filled',
    ref,
    icon: element,
  },
));

ThumbDownFilledIcon.displayName = 'ThumbDownFilledIcon';

export default ThumbDownFilledIcon;
